import type { MessageToast } from '~/modules/campaign/types';
import type { ICampaignGroup } from '../types';

import { useMutationCampaignGroupBase } from './useMutationCampaignGroupBase';
import { CAMPAIGN_GROUP_MSG } from '../constants';
import { useCampaignGroupStore } from '../stores';
import { useToast } from '~/hooks/useToast';
import { useState } from 'react';

export interface IUpdateCampaign<T extends ICampaignGroup> {
  isLoadingUpdate: boolean;
  onUpdate: (data?: T, message?: MessageToast) => Promise<T | undefined>;
}

export const useMutationCGSettings = <T extends ICampaignGroup>(): IUpdateCampaign<T> => {
  const campaignGroupStore = useCampaignGroupStore();
  const { shopifyToast } = useToast();
  const { updateCampaignGroupBase } = useMutationCampaignGroupBase();
  // const { onSyncMetafieldCampaignPrice } = useSyncMetafieldCampaignPrice();

  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);

  const onUpdate = async (
    data?: T,
    message = CAMPAIGN_GROUP_MSG.UPDATE,
  ): Promise<T | undefined> => {
    if (!data) return;
    setIsLoadingUpdate(true);

    try {
      const dateUpdated = (await updateCampaignGroupBase(data)) as T;

      campaignGroupStore.upsertCampaignGroup(data);
      shopifyToast(message.SUCCESS);
      return dateUpdated;
    } catch (error) {
      shopifyToast(message.FAILED, { isError: true });
      return;
    } finally {
      setIsLoadingUpdate(false);
    }
  };

  return {
    isLoadingUpdate,
    onUpdate,
  };
};
